export default {
  welcome: "Welcome back, {name}",
  subtitle: "Here's what's happening with your projects today",
  guest: "Guest",
  entity_cards: {
    machines: "Machines",
    materials: "Materials",
    users: "Users",
    projects: "Projects",
  },
  quick_actions: {
    title: "Quick Actions",
    new_badge: "New",
    add_user: "Add User",
    add_user_subtitle: "Create a new employee account",
    add_project: "Create Project",
    add_project_subtitle: "Set up a new project",
    visit_costs: "Running Post-Calculation",
    visit_costs_subtitle: "View project costs",
    visit_hourlywageinvoice: "[[HWI]]",
    visit_hourlywageinvoice_subtitle: "View and manage invoices",
    visit_timetracking: "Time Tracking",
    visit_timetracking_subtitle: "Record and approve working hours",
    visit_files: "Files",
    visit_files_subtitle: "All documents in one place",
    visit_personnelplanning: "Personnel Planning",
    visit_personnelplanning_subtitle: "Plan your employees' assignments",
    add_customer: "Create Customer",
    add_customer_subtitle: "Add a new customer",
    add_material: "Create Material",
    add_material_subtitle: "Add a new material",
    add_machine: "Create Machine",
    add_machine_subtitle: "Add a new machine",
    add_additionaleffort: "Create Additional Effort",
    add_additionaleffort_subtitle: "Add a new additional effort",
    visit_projects: "Projects",
    visit_projects_subtitle: "View all projects",
  },
  recent_projects: {
    title: "Recently Visited Projects",
    empty: "No recent projects",
  },
  recent_activity: {
    title: "Recent Activity",
    show_all: "Show all",
    empty: "No recent activity",
  },
}
